import { render } from "./ApiUsageControls.vue?vue&type=template&id=06c1e9fe"
import script from "./ApiUsageControls.vue?vue&type=script&lang=js"
export * from "./ApiUsageControls.vue?vue&type=script&lang=js"
script.render = render

export default script